import { render, staticRenderFns } from "./IbanDetailsModal.vue?vue&type=template&id=7f9f9811&scoped=true"
import script from "./IbanDetailsModal.vue?vue&type=script&lang=js"
export * from "./IbanDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./IbanDetailsModal.vue?vue&type=style&index=0&id=7f9f9811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f9811",
  null
  
)

export default component.exports